module.exports = __webpack_public_path__ + "static/img/COVER.ff25dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER.png
// module id = z8cO
// module chunks = 31